import { State, Action, StateContext, Selector, Store, Select } from '@ngxs/store';
import {
  SendMessage,
  ThreadReply,
  GetMessageVariables,
  MessageAlertDismissed,
  GetMessageThreadHistory,  // Remove with the deprecation of Inbox and wrap-up-dialog new email implemenatation
  GetMessageThreadFullHistory,  // Remove with the deprecation of Inbox and wrap-up-dialog new email implemenatation
  ClearThreadStore,  // Remove with the deprecation of Inbox and wrap-up-dialog new email implemenatation
  MessageRead,
  SubscribeToBorrowerMessages,  // Remove with the deprecation of Inbox and wrap-up-dialog new email implemenatation
  GetUnknownThreads,
  AddBorrowerToMessage,
  DeleteMessageFromUnknownSender,
  PatchIndividualThread,
  GetInboxEmailList,
  GetActiveEmailThread,
  ClearEmailsStore,
  MarkBorrowerThreadRead,
  SendNewMessage,
  SendThreadReply,
  GetLendioEmailDirectory,
  GetMarketingEmailList,
  SubscribeToBorrowerEmails,
  RefreshInboxEmailList,
  GetAllEmailList,
  RefreshAllEmailList,
  GetEmailSignature,
  GetPreviewMessage, ClearPreviewMessage,
} from './message.actions';
import { MessageService } from '../message-service/message.service';
import { tap, catchError, map } from 'rxjs/operators';
import { throwError, of, Observable } from 'rxjs';
import { MessageVariables } from '../message-service/message-variables.model';
import { Alert } from 'ng2-app/components/alert/alert.interface';
import { Injectable } from '@angular/core';
import { Thread, Message, EmailList, EmailListResponse } from '../message-service/message.model';
import { PusherService } from 'app/modules/shared/services/pusher.service';
import * as _ from 'lodash';
import { UnknownInboxItemPaginationData } from 'app/modules/task-management/models/unknown-inbox-item/unknown-inbox-item-pagination-data.model';
import { MarkMessageAsRead, SetActiveThread } from 'ng2-app/modules/today/state/email/user-threads.action';
import { append, patch, updateItem } from '@ngxs/store/operators';
import { format } from 'date-fns';
import { EmailDirectoryListItem } from 'app/models/dto/directory-list-item.model';
import { cloneDeep } from 'lodash';
import { LenderUserState } from 'app/store/lender-user/lender-user/lender-user.state';
import { LenderUser } from 'app/models/dto/lender-user.model';
import { EventBusService } from 'ng2-app/modules/shared/services/event-bus.service';
import { CloseSendEmailViewEvent } from 'ng2-app/modules/shared/services/event-types';

export class MessageStateModel {
    borrowerId: number | null;
    threads: Thread[];
    inboxEmailList: EmailList[];
    marketingEmailList: EmailList[];
    allEmailList: EmailList[];
    createdEmailsTotal: number;
    inboxThreadTotal: number;
    moreAllEmailsAvailable: boolean;
    moreInboxEmailsAvailable: boolean;
    moreMarketingEmailsAvailable: boolean;
    sortOrder: {
        All: 'asc' | 'desc';
        Inbox: 'asc' | 'desc';
        Marketing: 'asc' | 'desc';
    };
    loadingInitialEmailList: {
        All: boolean;
        Inbox: boolean;
        Marketing: boolean;
    };
    activeEmailThread: Thread | null;
    loadingActiveEmailThread: boolean;
    unknownThreads: Thread[];
    messageVariables: MessageVariables | any;
    emailSignature: string;
    alert: null | Alert;
    loadingInitial: boolean;
    loadingAll: boolean;
    loading: boolean;
    disableLoadAll: boolean;
    unknownThreadsNextPageUrl: null | string;
    unknownThreadsCurrentPage: number;
    unknownThreadsLastPage: number;
    loadingLendioEmailDirectory: boolean;
    lendioEmailDirectory: EmailDirectoryListItem[];
    messagePreview: any;
}

@State<Partial<MessageStateModel>>({
    name: 'message',
    defaults: {
        threads: [],
        inboxEmailList: [],
        marketingEmailList: [],
        allEmailList: [],
        createdEmailsTotal: 0,
        inboxThreadTotal: 0,
        moreAllEmailsAvailable: false,
        moreInboxEmailsAvailable: false,
        moreMarketingEmailsAvailable: false,
        sortOrder: {
            All: 'desc',
            Inbox: 'desc',
            Marketing: 'desc',
        },
        loadingInitialEmailList: {
            All: true,
            Inbox: true,
            Marketing: true,
        },
        loadingActiveEmailThread: false,
        unknownThreads: [],
        unknownThreadsNextPageUrl: null,
        unknownThreadsCurrentPage: 0,
        unknownThreadsLastPage: 0,
        loadingInitial: false,
        loadingAll: false,
        loading: false,
        disableLoadAll: false,
        loadingLendioEmailDirectory: false,
        lendioEmailDirectory: [],
    }
})

@Injectable()

export class MessageState {

    @Selector()
    static threads(state: MessageStateModel) {
        return state.threads;
    }

  @Selector()
  static messagePreview(state: MessageStateModel) {
    return state.messagePreview;
  }

    @Selector()
    static inboxEmailList(state: MessageStateModel) {
        return state.inboxEmailList;
    }

    @Selector()
    static marketingEmailList(state: MessageStateModel) {
        return state.marketingEmailList;
    }

    @Selector()
    static allEmailList(state: MessageStateModel) {
        return state.allEmailList;
    }

    @Selector()
    static inboxThreadTotal(state: MessageStateModel) {
        return state.inboxThreadTotal;
    }

    @Selector()
    static moreAllEmailsAvailable(state: MessageStateModel) {
        return state.moreAllEmailsAvailable;
    }

    @Selector()
    static moreInboxEmailsAvailable(state: MessageStateModel) {
        return state.moreInboxEmailsAvailable;
    }

    @Selector()
    static moreMarketingEmailsAvailable(state: MessageStateModel) {
        return state.moreMarketingEmailsAvailable;
    }

    @Selector()
    static loading(state: MessageStateModel) {
        return state.loading;
    }

    @Selector()
    static sortOrder(state: MessageStateModel) {
        return state.sortOrder;
    }

    @Selector()
    static activeEmailThread(state: MessageStateModel) {
        return state.activeEmailThread;
    }

    @Selector()
    static loadingActiveEmailThread(state: MessageStateModel) {
        return state.loadingActiveEmailThread;
    }

    @Selector()
    static alert(state: MessageStateModel) {
        return state.alert;
    }

    @Selector()
    static unknownMessages(state: MessageStateModel) {
        let messages: Message[] = [];
        state.unknownThreads.forEach((thread) => {
            messages = messages.concat(thread.messages);
        });
        return messages;
    }

    @Selector()
    static paginationData(state: MessageStateModel): UnknownInboxItemPaginationData {
        return {
            currentPage: state.unknownThreadsCurrentPage,
            lastPage: state.unknownThreadsLastPage,
            nextPageUrl: state.unknownThreadsNextPageUrl
        };
    }

    @Selector()
    static loadingLendioEmailDirectory(state: MessageStateModel) {
        return state.loadingLendioEmailDirectory;
    }

    @Selector()
    static lendioEmailDirectory(state: MessageStateModel) {
        return state.lendioEmailDirectory;
    }

    @Select(LenderUserState.lenderUser) lenderUser$: Observable<LenderUser>;

    badEmailMessage = 'The recipient address wasn\'t found.  Please verify all email addresses.';
    private currentUser: LenderUser;

    constructor(
      private messageService: MessageService,
      private pusherService: PusherService,
      private store: Store,
      private eventBusService: EventBusService
    ) {
        this.lenderUser$.subscribe((currentUser) => {
            this.currentUser = currentUser;
        });
    }

    @Action(GetPreviewMessage)
    GetPreviewMessage(
      ctx: StateContext<MessageStateModel>,
      { message }: GetPreviewMessage,
    ) {
      ctx.patchState({
        loading: true,
      });
      return this.messageService.previewMessage(message).pipe(
        catchError(error => {
          ctx.patchState({
            loading: false,
          });
          return throwError(error);
        }),
        tap( messagePreview => {
          ctx.patchState({
            messagePreview,
            loading: false,
          });
        }),
      );
    }

    @Action(ClearPreviewMessage)
    ClearPreviewMessage(
      ctx: StateContext<MessageStateModel>,
      { }: ClearPreviewMessage,
    ) {
      ctx.patchState({
        messagePreview: undefined,
      });
    }

    @Action(SendMessage)
    sendMessage({ getState, patchState }: StateContext<MessageStateModel>, { message }: SendMessage) {
        return this.messageService.send(message).pipe(catchError(err => {
            switch (err) {
                case 'FORBIDDEN':
                    patchState({
                        alert: {
                            level: 'error',
                            message: 'Access denied or borrower is in the DNC list.'
                        }
                    });
                    this.dismissDelay();
                    break;
                case 'BAD REQUEST':
                    patchState({
                        alert: {
                            level: 'error',
                            message: this.badEmailMessage
                        }
                    });
                    this.dismissDelay();
                    break;
                case 'BORROWER NOT FOUND':
                    patchState({
                        alert: {
                            level: 'error',
                            message: 'The borrower wasn\'t found.  Please verify borrower information.'
                        }
                    });
                    this.dismissDelay();
                    break;
                default: // encapsulates 400 (MessageBag flavor) and 500 response codes
                    if (err.data.error.includes('Recipient has an invalid email address')) {
                        patchState({
                            alert: {
                                level: 'error',
                                message: this.badEmailMessage
                            }
                        });
                        this.dismissDelay();
                        err = 'BAD REQUEST: Recipient has an invalid email address';
                    } else {
                        patchState({
                            alert: {
                                level: 'error',
                                message: 'Failed to send email due to server error or error from client.'
                            }
                        });
                        this.dismissDelay();
                    }
                    break;
            }
            return of();
        }),
            map(response => {
                patchState({
                    alert: {
                        level: 'success',
                        message: 'The email message sent successfully!'
                    }
                });
                this.eventBusService.publish( new CloseSendEmailViewEvent() );
                this.dismissDelay();
                const state = getState();
                const threadList = [...state.threads];
                threadList.unshift(response);
                patchState({
                    threads: threadList
                });
            }));
    }

    @Action(ThreadReply)
    threadReply({ getState, patchState }: StateContext<MessageStateModel>, { id, message }: ThreadReply) {
        return this.messageService.put(id, message).pipe(catchError(err => {
            patchState({
                alert: {
                    level: 'error',
                    message: 'Failed to send email due to server error or error from client.'
                }
            });
            return of();
        }),
        tap(thread => {
            if (thread) {
                patchState({
                    alert: {
                        level: 'success',
                        message: 'The email message sent successfully!'
                    }
                });
                this.dismissDelay();
                const state = getState();
                const threadList = [...state.threads];
                const threadIndex = threadList.findIndex(item => item.id === id);
                threadList[threadIndex] = thread;
                this.sortThreads(threadList);
                patchState({
                    threads: threadList
                });
                // Update the activeThread for the Today page.
                this.store.dispatch(new SetActiveThread(thread));
            }
        }));
    }

    @Action(SendThreadReply)
    sendThreadReply({ getState, patchState }: StateContext<MessageStateModel>, { id, message }: SendThreadReply) {
        return this.messageService.put(id, message).pipe(catchError(() => {
            patchState({
                alert: {
                    level: 'error',
                    message: 'Failed to send email due to server error or error from client.'
                }
            });
            return of();
        }),
        tap(thread => {
            if (thread) {
                patchState({
                    alert: {
                        level: 'success',
                        message: 'The email message sent successfully!'
                    },
                    loadingActiveEmailThread: true
                });
                this.dismissDelay();
                const state = getState();
                const sortOrder = state.sortOrder;
                const threadList = [...state.threads];
                let inboxEmailListCopy = [...state.inboxEmailList];
                let allEmailListCopy = [...state.allEmailList];
                const threadIndex = threadList.findIndex(item => item.id === id);
                const inboxEmailListIndex = inboxEmailListCopy.findIndex(item => item.threadId === id);
                threadList[threadIndex] = thread;
                this.sortThreads(threadList);
                const messages = _.orderBy(thread.messages, ['created'], ['desc']);
                const recentTime: string = messages[0].created as string;
                const newEmailListThread: EmailList = {
                    threadId: thread.id,
                    containsAttachment: thread.attachmentCount > 0,
                    borrowerId: thread.borrowerId,
                    recipientRecords: messages[0].recipientRecords,
                    unreadMessageCount: 0,
                    subject: thread.subject,
                    messageCount: messages.length.toString(),
                    mostRecentHtml: (messages[0]?.html?.replace(/(<[^>]*>)|\n/g, ' ')),
                    mostRecentMessageTime: this.getCurrentTimezoneDate(recentTime),
                    mostRecentPreview: (messages[0].html?.replace(/(<[^>]*>)|\n/g, ' ')),
                    created24HoursAgo: false
                };
                inboxEmailListCopy[inboxEmailListIndex] = newEmailListThread;
                if (allEmailListCopy.length) {
                    const allEmailListIndex = allEmailListCopy.findIndex(item => item.threadId === id);
                    allEmailListCopy[allEmailListIndex] = newEmailListThread;
                    allEmailListCopy = _.orderBy(allEmailListCopy, ['mostRecentMessageTime'], [sortOrder.All]);
                }
                inboxEmailListCopy = _.orderBy(inboxEmailListCopy, ['mostRecentMessageTime'], [sortOrder.Inbox]);
                patchState({
                    threads: threadList,
                    inboxEmailList: inboxEmailListCopy,
                    allEmailList: allEmailListCopy,
                    activeEmailThread: thread,
                    loadingActiveEmailThread: false
                });
            }
        }));
    }

    @Action(AddBorrowerToMessage)
    addBorrowerToMessage({ getState, patchState }: StateContext<MessageStateModel>, { id, borrower, threadId }: AddBorrowerToMessage) {
        const update = { borrowerId: borrower.id };
        return this.messageService.messagePut(id, update).pipe(
            catchError(() => {
                patchState({
                    alert: {
                        level: 'error',
                        message: 'Failed to save message to ' + borrower.name
                    }
                });
                this.dismissDelay();
                return of();
            }),
            tap(() => {
                const state = getState();
                patchState({
                    unknownThreads: state.unknownThreads.filter(thread => thread.id !== threadId),
                    alert: {
                        level: 'success',
                        message: 'Contact saved to ' + borrower.name
                    }
                });
            }));
    }

    @Action(GetMessageVariables)
    getMessageVariables({ patchState }: StateContext<MessageStateModel>, { borrowerId }: GetMessageVariables) {
        return this.messageService.getMessageVariables(borrowerId).pipe(catchError(err => throwError(() => err)),
            map(messageVariables => {
                patchState({ messageVariables });
            }));
    }

    @Action(GetEmailSignature)
    getEmailSignature({ patchState }: StateContext<MessageStateModel>, {}: GetMessageVariables) {
        return this.messageService.getEmailSignature().pipe(catchError(err => throwError(() => err)),
            map(emailSignature => {
                patchState({ emailSignature });
            }));
    }

    @Action(MessageRead)
    messageRead({ patchState, getState }: StateContext<MessageStateModel>, { message }: MessageRead) {
        const state = getState();
        const currentMessage = state.threads.filter(thread => thread.id === message.threadId)[0]?.messages
            .filter(filterMessage => filterMessage.id === message.id)[0];
        if (message.borrowerId && (!currentMessage || currentMessage.read !== null)) { return; }
        const threads = state.threads.map(thread => {
            thread.messages = thread.messages.map(mapMessage => {
                if (message.id !== mapMessage.id) {
                    return mapMessage;
                }
                mapMessage.read = (new Date).toISOString();
                return message;
            });
            return thread;

        });
        patchState({ threads });

        return this.messageService.messageRead(message.id).pipe(
            catchError(err => throwError(() => err)),
            map(() => {
                this.store.dispatch(new MarkMessageAsRead(message));
            })
        );
    }

    @Action(MarkBorrowerThreadRead)
    markBorrowerThreadRead(
        { setState }: StateContext<MessageStateModel>,
        { threadId }: MarkBorrowerThreadRead
    ) {
        return this.messageService.markThreadRead(threadId).pipe(catchError(err => of()), map((res) => {
                setState(patch({
                    threads: updateItem((thread: Thread) => thread?.id === threadId, patch({
                        unreadMessageCount: 0
                    })),
                    inboxEmailList: updateItem((emailThread: EmailList) => emailThread?.threadId === threadId, patch({
                        unreadMessageCount: 0
                    }))
                }));
            })
        );
    }

    @Action(MessageAlertDismissed)
    messageAlertDismissed({ patchState }: StateContext<MessageStateModel>) {
        patchState({ alert: null });
    }

    @Action(SendNewMessage)
    sendNewMessage({ getState, patchState }: StateContext<MessageStateModel>, { message }: SendNewMessage) {
        return this.messageService.send(message).pipe(catchError(err => {
            switch (err) {
                case 'FORBIDDEN':
                    patchState({
                        alert: {
                            level: 'error',
                            message: 'Access denied or borrower is in the DNC list.'
                        }
                    });
                    this.dismissDelay();
                break;
                case 'BAD REQUEST':
                    patchState({
                        alert: {
                            level: 'error',
                            message: this.badEmailMessage
                        }
                    });
                    this.dismissDelay();
                break;
                case 'BORROWER NOT FOUND':
                    patchState({
                        alert: {
                            level: 'error',
                            message: 'The borrower wasn\'t found.  Please verify borrower information.'
                        }
                    });
                    this.dismissDelay();
                break;
                default: // encapsulates 400 (MessageBag flavor) and 500 response codes
                    if (err.data.error.includes('Recipient has an invalid email address')) {
                        patchState({
                            alert: {
                                level: 'error',
                                message: this.badEmailMessage
                            }
                        });
                        this.dismissDelay();
                        err = 'BAD REQUEST: Recipient has an invalid email address';
                    } else {
                        patchState({
                            alert: {
                                level: 'error',
                                message: 'Failed to send email due to server error or error from client.'
                            }
                        });
                        this.dismissDelay();
                    }
                break;
            }
            return of();
        }),
        map(response => {
            patchState({
                alert: {
                    level: 'success',
                    message: 'The email message sent successfully!'
                }
            });
            this.dismissDelay();
            const state = getState();
            const threadList = [...state.threads];
            const inboxThreadTotal = state.inboxThreadTotal + 1;
            const inboxEmailList = [...state.inboxEmailList];
            const allEmailList = [...state.allEmailList];
            const createdEmailsTotalCopy = state.createdEmailsTotal + 1;
            const recentTime: string = response.messages[0].created as string;
            const newThread: EmailList = {
                threadId: response.id,
                containsAttachment: response.attachmentCount > 0,
                borrowerId: response.borrowerId,
                recipientRecords: response.messages[0].recipientRecords,
                unreadMessageCount: 0,
                subject: response.subject,
                messageCount: '1',
                mostRecentHtml: (response?.messages[0]?.html?.replace(/(<[^>]*>)|\n/g, ' ')),
                mostRecentMessageTime: this.getCurrentTimezoneDate(recentTime),
                mostRecentPreview: (response.messages[0].html?.replace(/(<[^>]*>)|\n/g, ' ')),
                created24HoursAgo: false
            };
            threadList.unshift(response);
            inboxEmailList.unshift(newThread);
            if (allEmailList.length) {
                allEmailList.unshift(newThread);
                patchState({
                    allEmailList
                });
            }

            patchState({
                threads: threadList,
                inboxEmailList,
                inboxThreadTotal: inboxThreadTotal,
                createdEmailsTotal: createdEmailsTotalCopy,
                activeEmailThread: response
            });
        }));
    }

    @Action(GetLendioEmailDirectory, { cancelUncompleted: true })
    getLendioEmailDirectory({ patchState }: StateContext<MessageStateModel>) {
        patchState({ loadingLendioEmailDirectory: true });
        this.messageService.getLendioEmailDirectory().pipe(
            catchError(() => {
                patchState({
                    alert: {
                        level: 'error',
                        message: 'Failed to retrieve the Lendio Email Directory.  Please reload page to try again.'
                    },
                    loadingLendioEmailDirectory: false
                });
                this.dismissDelay();
                return of([]);
            }),
            tap((lendioEmailDirectory) => {
                patchState({ loadingLendioEmailDirectory: false,  lendioEmailDirectory });
            })
        ).subscribe();
    }

    @Action(GetInboxEmailList, { cancelUncompleted: true })
    getInboxEmailList(
        { getState, patchState }: StateContext<MessageStateModel>,
        { borrower, loadMore, sort }: GetInboxEmailList) {
        const loadingInitialEmailList = getState().loadingInitialEmailList;
        let moreInboxEmailsAvailable = getState().moreInboxEmailsAvailable;
        let inboxEmailListCopy = [...getState().inboxEmailList];
        const createdEmailsTotalCopy = getState().createdEmailsTotal;
        // Get the true email list length (subtracting newly created emails sent by reps)
        const inboxEmailListLength = inboxEmailListCopy.length - createdEmailsTotalCopy;
        const sortOrderCopy = getState().sortOrder;
        if (!!sort) {
            sortOrderCopy.Inbox = sortOrderCopy.Inbox === 'desc' ? 'asc' : 'desc';
        }

        /**
         * Make an Api call if one of the following is met:
         * 1. Loading more
         * 2. First retrieval
         * 3. Sorting and we don't have all existing email list threads in state
         * */
        if (loadMore || loadingInitialEmailList.Inbox || (!!sort && moreInboxEmailsAvailable)) {
            patchState({ loading: true });
            const limit = 20;
            const offset = sort ? 0 : inboxEmailListLength;
            const filterBy = 'inbox';
            loadingInitialEmailList.Inbox = false;

            return this.messageService.getBorrowerEmailList(filterBy, limit, offset, sortOrderCopy.Inbox, borrower.id).pipe(
                catchError((): Observable<EmailListResponse> => {
                    patchState({
                        alert: {
                            level: 'error',
                            message: `Failed to retrieve borrower ${filterBy} emails. Please reload page to try again.`
                        },
                        loading: false
                    });
                    this.dismissDelay();

                    return of({
                      emailList: [],
                      totalThreadCount: 0,
                    });
                }),
                tap((response) => {
                    response?.emailList?.forEach((thread: EmailList) => {
                        thread.mostRecentPreview = thread.mostRecentHtml?.replace(/(<[^>]*>)|\n/g, ' ');
                        thread.created24HoursAgo = this.calculateHourDifference(thread.mostRecentMessageTime);
                        thread.mostRecentMessageTime = this.getCurrentTimezoneDate(thread.mostRecentMessageTime);
                        thread.type = 'inbox';
                    });

                    if (!!offset) {
                        // Loading more
                        inboxEmailListCopy = this.removeDuplicates(inboxEmailListCopy, response?.emailList);
                        inboxEmailListCopy = _.orderBy(inboxEmailListCopy, ['mostRecentMessageTime'], [sortOrderCopy.Inbox]);
                        moreInboxEmailsAvailable = response?.totalThreadCount > inboxEmailListCopy.length;

                        patchState({
                            inboxEmailList: inboxEmailListCopy,
                            inboxThreadTotal: response?.totalThreadCount,
                            moreInboxEmailsAvailable,
                            loading: false
                        });
                    } else {
                        inboxEmailListCopy = response?.emailList;
                        inboxEmailListCopy = _.orderBy(inboxEmailListCopy, ['mostRecentMessageTime'], [sortOrderCopy.Inbox]);
                        moreInboxEmailsAvailable = response?.totalThreadCount > inboxEmailListCopy.length;

                        // First retrieval, sorted retrieval, or there are no emails
                        patchState({
                            inboxEmailList: inboxEmailListCopy,
                            inboxThreadTotal: response?.totalThreadCount,
                            borrowerId: borrower.id,
                            loadingInitialEmailList,
                            moreInboxEmailsAvailable,
                            sortOrder: sortOrderCopy,
                            loading: false
                        });
                    }
                    if (!loadMore && inboxEmailListCopy?.length > 0) {
                        this.store.dispatch(new GetActiveEmailThread(inboxEmailListCopy[0].threadId, false));
                        if (this.currentUser.id === borrower.userId) {
                            this.store.dispatch(new MarkBorrowerThreadRead(inboxEmailListCopy[0].threadId));
                        }
                    }
                })
            );
            //Sort through state if we have all existing email list threads
        } else if (!!sort) {
            inboxEmailListCopy = _.orderBy(inboxEmailListCopy, ['mostRecentMessageTime'], [sortOrderCopy.Inbox]);
            patchState({
                inboxEmailList: inboxEmailListCopy,
                sortOrder: sortOrderCopy
            });
        } else {
            inboxEmailListCopy = _.orderBy(inboxEmailListCopy, ['mostRecentMessageTime'], [sortOrderCopy.Inbox]);
            if (inboxEmailListCopy.length) {
                this.store.dispatch(new GetActiveEmailThread(inboxEmailListCopy[0].threadId, false));
                return;
            } else {
                return;
            }
        }
    }

    @Action(RefreshInboxEmailList, { cancelUncompleted: true })
    refreshInboxEmailList (
        { getState, patchState }: StateContext<MessageStateModel>,
        { borrowerId }: RefreshInboxEmailList) {
        let inboxEmailListCopy = [...getState().inboxEmailList];
        const createdEmailsTotalCopy = getState().createdEmailsTotal;
        // Get the true email list length (subtracting newly created emails sent by reps)
        const inboxEmailListLength = inboxEmailListCopy.length - createdEmailsTotalCopy;
        const sortOrderCopy = getState().sortOrder;
        const activeEmailThread = getState().activeEmailThread;
        const limit = inboxEmailListLength <= 0 ? 20 : inboxEmailListLength;
        const offset = 0;
        const filterBy = 'inbox';
        const allEmailListCopy = [...getState().allEmailList];
        if (allEmailListCopy.length) {
            this.store.dispatch(new RefreshAllEmailList(borrowerId));
        }

        return this.messageService.getBorrowerEmailList(filterBy, limit, offset, sortOrderCopy.Inbox, borrowerId).pipe(catchError(() => {
            patchState({
                alert: {
                    level: 'error',
                    message: 'Failed to refresh borrower emails. Please reload page to try again.'
                },
                loading: false
            });
            this.dismissDelay();
            return of([]);
        }),
            tap((response) => {
                if (!response['emailList']) {
                    return;
                }
                const inboxThreadTotal = response['totalThreadCount'] ?? 0;

                response['emailList'].forEach((thread: EmailList) => {
                    thread.mostRecentPreview = thread.mostRecentHtml?.replace(/(<[^>]*>)|\n/g, ' ');
                    thread.created24HoursAgo = this.calculateHourDifference(thread.mostRecentMessageTime);
                    thread.mostRecentMessageTime = this.getCurrentTimezoneDate(thread.mostRecentMessageTime);
                });

                inboxEmailListCopy = this.removeDuplicates(inboxEmailListCopy, response['emailList']);
                inboxEmailListCopy = _.orderBy(inboxEmailListCopy, ['mostRecentMessageTime'], [sortOrderCopy.Inbox]);

                if (inboxEmailListCopy?.length > 0) {
                    const activeThreadId = !!activeEmailThread ? activeEmailThread.id : inboxEmailListCopy[0].threadId ?? null;
                    if (!!activeThreadId) {
                        const threads = getState().threads.filter(thread => thread.id === activeThreadId);
                        patchState({ threads });
                        this.store.dispatch(new GetActiveEmailThread(activeThreadId, true));
                    }

                    patchState({
                        inboxEmailList: inboxEmailListCopy,
                        inboxThreadTotal: inboxThreadTotal
                    });
                }
            })
        );
    }

    @Action(RefreshAllEmailList, { cancelUncompleted: true })
    refreshAllEmailList (
        { getState, patchState }: StateContext<MessageStateModel>,
        { borrowerId }: RefreshAllEmailList) {
        let allEmailListCopy = [...getState().inboxEmailList];
        const createdEmailsTotalCopy = getState().createdEmailsTotal;
        // Get the true email list length (subtracting newly created emails sent by reps)
        const allEmailListLength = allEmailListCopy.length - createdEmailsTotalCopy;
        const sortOrderCopy = getState().sortOrder;
        const limit = allEmailListLength;
        const offset = 0;
        const filterBy = 'all';

        return this.messageService.getBorrowerEmailList(filterBy, limit, offset, sortOrderCopy.All, borrowerId).pipe(catchError(() => {
            patchState({
                alert: {
                    level: 'error',
                    message: 'Failed to refresh borrower emails. Please reload page to try again.'
                },
                loading: false
            });
            this.dismissDelay();
            return of([]);
        }),
            tap((response) => {
                if (!response['emailList']) {
                    return;
                }

                response['emailList'].forEach((thread: EmailList) => {
                    thread.mostRecentPreview = thread.mostRecentHtml?.replace(/(<[^>]*>)|\n/g, ' ');
                    thread.created24HoursAgo = this.calculateHourDifference(thread.mostRecentMessageTime);
                    thread.mostRecentMessageTime = this.getCurrentTimezoneDate(thread.mostRecentMessageTime);
                });

                allEmailListCopy = this.removeDuplicates(allEmailListCopy, response['emailList']);
                allEmailListCopy = _.orderBy(allEmailListCopy, ['mostRecentMessageTime'], [sortOrderCopy.All]);

                patchState({ allEmailList: allEmailListCopy });
            })
        );
    }

    @Action(GetMarketingEmailList, { cancelUncompleted: true })
    getMarketingEmailList(
        { getState, patchState }: StateContext<MessageStateModel>,
        {borrowerId, loadMore, sort }: GetMarketingEmailList) {
        const loadingInitialEmailList = getState().loadingInitialEmailList;
        let marketingEmailListCopy = [...getState().marketingEmailList];
        let moreMarketingEmailsAvailable = getState().moreMarketingEmailsAvailable;
        const marketingEmailListLength = marketingEmailListCopy.length;
        const sortOrderCopy = getState().sortOrder;
        if (!!sort) {
            sortOrderCopy.Marketing = sortOrderCopy.Marketing === 'desc' ? 'asc' : 'desc';
        }
        /**
         * Make an Api call if one of the following is met:
         * 1. Loading more
         * 2. First retrieval
         * 3. Sorting and we don't have all existing email list threads in state
         * */
        if (loadMore || loadingInitialEmailList.Marketing || (!!sort && moreMarketingEmailsAvailable)) {
            patchState({ loading: true });
            const limit = 20;
            const offset = sort ? 0 : marketingEmailListLength;
            const startingCount = marketingEmailListLength;
            const filterBy = 'marketing';
            loadingInitialEmailList.Marketing = false;

            return this.messageService.getBorrowerEmailList(filterBy, limit, offset, sortOrderCopy.Marketing, borrowerId).pipe(
                catchError(() => {
                patchState({
                    alert: {
                        level: 'error',
                        message: 'Failed to retrieve borrower marketing emails. Please reload page to try again.'
                    },
                    loading: false
                });
                this.dismissDelay();
                return of([]);
            }),
                tap((response) => {
                    const responseLength = response['emailList'].length;
                    const responseThreadCount = response['totalThreadCount'];
                    response['emailList'].forEach((thread: EmailList) => {
                        thread.mostRecentPreview = thread.mostRecentHtml?.replace(/(<[^>]*>)|\n/g, ' ');
                        thread.created24HoursAgo = this.calculateHourDifference(thread.mostRecentMessageTime);
                        thread.mostRecentMessageTime = this.getCurrentTimezoneDate(thread.mostRecentMessageTime);
                    });
                    if (!!offset) {
                        // Loading more
                        marketingEmailListCopy.push(...response['emailList']);
                        marketingEmailListCopy = this.removeDuplicates(marketingEmailListCopy, response['emailList']);
                        marketingEmailListCopy = _.orderBy(marketingEmailListCopy, ['mostRecentMessageTime'], [sortOrderCopy.Marketing]);
                        moreMarketingEmailsAvailable = (responseLength < limit) ? false :
                            ((startingCount === marketingEmailListCopy.length) ||
                            (responseThreadCount === marketingEmailListCopy.length)) ? false : true;
                        patchState({
                            marketingEmailList: marketingEmailListCopy,
                            moreMarketingEmailsAvailable,
                            loading: false
                        });
                    } else {
                        marketingEmailListCopy = response['emailList'];
                        marketingEmailListCopy = _.orderBy(marketingEmailListCopy, ['mostRecentMessageTime'], [sortOrderCopy.Marketing]);
                        moreMarketingEmailsAvailable = (responseLength < responseThreadCount);

                        // First retrieval, sorted retrieval, or there are no emails
                        patchState({
                            marketingEmailList: marketingEmailListCopy,
                            moreMarketingEmailsAvailable,
                            borrowerId,
                            loadingInitialEmailList,
                            sortOrder: sortOrderCopy,
                            loading: false
                        });
                    }
                    if (!loadMore && marketingEmailListCopy?.length > 0) {
                        this.store.dispatch(new GetActiveEmailThread(marketingEmailListCopy[0].threadId, false));
                    }
                }));
            //Sort through state if we have all existing email list threads
        } else if (!!sort) {
            marketingEmailListCopy = _.orderBy(marketingEmailListCopy, ['mostRecentMessageTime'], [sortOrderCopy.Marketing]);
            patchState({
                marketingEmailList: marketingEmailListCopy,
                sortOrder: sortOrderCopy
            });
        } else {
            marketingEmailListCopy = _.orderBy(marketingEmailListCopy, ['mostRecentMessageTime'], [sortOrderCopy.Marketing]);
            if (marketingEmailListCopy.length) {
                this.store.dispatch(new GetActiveEmailThread(marketingEmailListCopy[0].threadId, false));
                return;
            } else {
                return;
            }
        }
    }

    @Action(GetAllEmailList, { cancelUncompleted: true })
    getAllEmailList(
        { getState, patchState }: StateContext<MessageStateModel>,
        {borrowerId, loadMore, sort }: GetAllEmailList) {
        const loadingInitialEmailList = getState().loadingInitialEmailList;
        let allEmailListCopy = [...getState().allEmailList];
        let moreAllEmailsAvailable = getState().moreAllEmailsAvailable;
        const allEmailListLength = allEmailListCopy.length;
        const sortOrderCopy = getState().sortOrder;
        if (!!sort) {
            sortOrderCopy.All = sortOrderCopy.All === 'desc' ? 'asc' : 'desc';
        }
        /**
         * Make an Api call if one of the following is met:
         * 1. Loading more
         * 2. First retrieval
         * 3. Sorting and we don't have all existing email list threads in state
         * */
        if (loadMore || loadingInitialEmailList.All || (!!sort && moreAllEmailsAvailable)) {
            patchState({ loading: true });
            const limit = 20;
            const offset = sort ? 0 : allEmailListLength;
            const startingCount = allEmailListLength;
            const filterBy = 'all';
            loadingInitialEmailList.All = false;
            return this.messageService.getBorrowerEmailList(filterBy, limit, offset, sortOrderCopy.All, borrowerId).pipe(
                catchError(() => {
                patchState({
                    alert: {
                        level: 'error',
                        message: 'Failed to retrieve all of the borrower emails. Please reload page to try again.'
                    },
                    loading: false
                });
                this.dismissDelay();
                return of([]);
            }),
                tap((response) => {
                    const responseLength = response['emailList'].length;
                    const responseThreadCount = response['totalThreadCount'];
                    response['emailList'].forEach((thread: EmailList) => {
                        thread.mostRecentPreview = thread.mostRecentHtml?.replace(/(<[^>]*>)|\n/g, ' ');
                        thread.created24HoursAgo = this.calculateHourDifference(thread.mostRecentMessageTime);
                        thread.mostRecentMessageTime = this.getCurrentTimezoneDate(thread.mostRecentMessageTime);
                    });
                    if (!!offset) {
                        // Loading more
                        allEmailListCopy.push(...response['emailList']);
                        allEmailListCopy = this.removeDuplicates(allEmailListCopy, response['emailList']);
                        allEmailListCopy = _.orderBy(allEmailListCopy, ['mostRecentMessageTime'], [sortOrderCopy.All]);
                        moreAllEmailsAvailable = (responseLength < limit) ? false :
                            ((startingCount === allEmailListCopy.length) ||
                            (responseThreadCount === allEmailListCopy.length)) ? false : true;
                        patchState({
                            allEmailList: allEmailListCopy,
                            moreAllEmailsAvailable,
                            loading: false
                        });
                    } else {
                        allEmailListCopy = response['emailList'];
                        allEmailListCopy = _.orderBy(allEmailListCopy, ['mostRecentMessageTime'], [sortOrderCopy.All]);
                        moreAllEmailsAvailable = (responseLength < responseThreadCount);

                        // First retrieval, sorted retrieval, or there are no emails
                        patchState({
                            allEmailList: allEmailListCopy,
                            moreAllEmailsAvailable,
                            borrowerId,
                            loadingInitialEmailList,
                            sortOrder: sortOrderCopy,
                            loading: false
                        });
                    }
                    if (!loadMore && allEmailListCopy?.length > 0) {
                        this.store.dispatch(new GetActiveEmailThread(allEmailListCopy[0].threadId, false));
                    }
                }));
            //Sort through state if we have all existing email list threads
        } else if (!!sort) {
            allEmailListCopy = _.orderBy(allEmailListCopy, ['mostRecentMessageTime'], [sortOrderCopy.All]);
            patchState({
                allEmailList: allEmailListCopy,
                sortOrder: sortOrderCopy
            });
        } else {
            allEmailListCopy = _.orderBy(allEmailListCopy, ['mostRecentMessageTime'], [sortOrderCopy.All]);
            if (allEmailListCopy.length) {
                this.store.dispatch(new GetActiveEmailThread(allEmailListCopy[0].threadId, false));
                return;
            } else {
                return;
            }
        }
    }


    @Action(GetActiveEmailThread, { cancelUncompleted: true })
    getThread({ getState, patchState }: StateContext<MessageStateModel>, { threadId, silentLoad }: GetActiveEmailThread
    ) {
        if (!silentLoad) {
            patchState({ loadingActiveEmailThread: true, activeEmailThread: null });
        }
        const threadInState: Thread = getState().threads.filter(t => t?.id === threadId)[0] ?? null;
        if (!!threadInState && !silentLoad) {
            setTimeout(() => {
                patchState({ loadingActiveEmailThread: false, activeEmailThread: threadInState });
              }, 200);
        } else {
            this.messageService.getSingleThread(threadId).pipe(catchError(() => {
                patchState({
                    alert: {
                        level: 'error',
                        message: 'Failed to get email content. Please reload page to try again.'
                    }
                });
                this.dismissDelay();
                return of(null);
            }), tap((thread: Thread) => {
                patchState({ loadingActiveEmailThread: false, activeEmailThread: thread });
                if (!!thread) {
                    this.store.dispatch(new PatchIndividualThread(thread));
                }
            })).subscribe();
        }
    }

    @Action(GetMessageThreadHistory, { cancelUncompleted: true })
    getMessageThreadHistory({ getState, patchState }: StateContext<MessageStateModel>, { borrowerId, refresh }: GetMessageThreadHistory) {
        patchState({ loadingInitial: true });
        const prevBorrowerId = getState().borrowerId;

        if (borrowerId === prevBorrowerId && !refresh) {
            return;
        }

        if (borrowerId !== prevBorrowerId) {
            if (prevBorrowerId) {
                this.pusherUnsubscribe(prevBorrowerId);
            }

            patchState({
                borrowerId,
                threads: [],
                loadingInitial: true
            });
        } else {
            patchState({
                loadingInitial: true
            });
        }

        return this.messageService.getMessageThreadHistory(borrowerId).pipe(catchError(() => {
            patchState({
                alert: {
                    level: 'error',
                    message: 'Failed to retrieve borrower emails. Please reload page to try again.'
                }
            });
            this.dismissDelay();
            return of([]);
        }), tap((threads: Thread[]) => {
            threads = _.orderBy(threads, ['modifiedTimestamp'], ['desc']);
            patchState({
                threads,
                loadingInitial: false,
                loadingAll: false,
                disableLoadAll: false
            });
        }));
    }

    @Action(GetMessageThreadFullHistory)
    getMessageThreadFullHistory({ patchState }: StateContext<MessageStateModel>, { borrowerId }: GetMessageThreadFullHistory) {
        patchState({ loadingAll: true, disableLoadAll: true });
        return this.messageService.getMessageThreadHistory(borrowerId, true).pipe(catchError(() => {
            patchState({
                alert: {
                    level: 'error',
                    message: 'Failed to retrieve borrower all borrower emails.  Please reload page and try again.'
                }
            });
            this.dismissDelay();
            patchState({ disableLoadAll: false });
            return of([]);
        }), tap((threads: Thread[]) => {
            threads = _.orderBy(threads, ['modifiedTimestamp'], ['desc']);
            patchState({ threads, loadingAll: false, disableLoadAll: true });
        }));
    }

    @Action(GetUnknownThreads)
    getUnknownThreads({ getState, patchState }: StateContext<MessageStateModel>, { lenderUserId }: GetUnknownThreads) {
        patchState({ loadingInitial: true });
        const { unknownThreadsCurrentPage, unknownThreadsLastPage, unknownThreadsNextPageUrl, unknownThreads } = getState();

        if (unknownThreadsCurrentPage && unknownThreadsCurrentPage >= unknownThreadsLastPage) {
            return;
        }

        return this.messageService.getUnknownThreads(lenderUserId, unknownThreadsNextPageUrl || null).pipe(
            catchError(() => {
                patchState({
                    alert: {
                        level: 'error',
                        message: 'Failed to get unknown messages.'
                    }
                });
                this.dismissDelay();
                return of();
            }),
            tap(unknownThreadsResponse => {
                patchState({
                    unknownThreads: [...unknownThreads, ...unknownThreadsResponse.data],
                    unknownThreadsCurrentPage: unknownThreadsResponse.current_page,
                    unknownThreadsLastPage: unknownThreadsResponse.last_page,
                    unknownThreadsNextPageUrl: unknownThreadsResponse.next_page_url,
                    loadingInitial: false
                });
            }
            ));
    }

    @Action(DeleteMessageFromUnknownSender)
    deleteMessageFromUnknown({ patchState, getState }: StateContext<MessageStateModel>,
        { messageId, threadId }: DeleteMessageFromUnknownSender) {
        return this.messageService.deleteMessageFromUnknownSender(messageId).pipe(
            catchError(() => {
                patchState({
                    alert: {
                        level: 'error',
                        message: 'Failed to delete message.'
                    }
                });
                this.dismissDelay();
                return of();
            }), tap(() => {
                const state = getState();
                const prunedUnknownThreads = state.unknownThreads.filter(thread => thread.id !== threadId);
                patchState({
                    unknownThreads: prunedUnknownThreads,
                    alert: {
                        level: 'success',
                        message: 'Successfully deleted message.'
                    }
                });
            })
        );
    }

    @Action(ClearThreadStore)
    clearThreadStore({ getState, patchState }: StateContext<MessageStateModel>, { borrowerId }: ClearThreadStore) {
        const prevBorrowerId = getState().borrowerId;

        if (prevBorrowerId) {
            this.pusherUnsubscribe(prevBorrowerId);
        }
        this.pusherUnsubscribe(borrowerId);
        patchState({
            borrowerId: null,
            threads: [],
            loadingInitial: true,
          messagePreview: undefined,
        });
    }

    @Action(ClearEmailsStore)
    clearEmails({ patchState }: StateContext<MessageStateModel>, { borrowerId }: ClearEmailsStore) {
        this.pusherUnsubscribe(borrowerId);

        patchState({
            borrowerId: null,
            threads: [],
            allEmailList: [],
            inboxEmailList: [],
            marketingEmailList: [],
            sortOrder: {
                All: 'desc',
                Inbox: 'desc',
                Marketing: 'desc'
            },
            inboxThreadTotal: 0,
            createdEmailsTotal: 0,
            activeEmailThread: null,
            loadingActiveEmailThread: false,
            loadingInitialEmailList: {
                All: true,
                Inbox: true,
                Marketing: true,
            },
            loading: false,
          messagePreview: undefined,
        });
    }

    @Action(SubscribeToBorrowerMessages, { cancelUncompleted: true })
    subscribeToBorrowerMessages(__: StateContext<MessageStateModel>, { borrowerId }: SubscribeToBorrowerMessages) {
        this.pusherSubscribe(borrowerId);
        return this.store.dispatch(new GetMessageThreadHistory(borrowerId));
    }

    @Action(PatchIndividualThread)
    patchIndividualThread({ getState, setState }: StateContext<MessageStateModel>, { thread }: PatchIndividualThread) {
        const current = getState();
        const currentThread = current.threads.filter(filterThread => filterThread.id === thread.id)[0];
        const currentThreads = currentThread ?
            updateItem<Thread>(patchFilterThread => patchFilterThread?.id === thread.id, thread) :
            append<Thread>([thread]);

        setState(patch({ threads: currentThreads}));
    }

    @Action(SubscribeToBorrowerEmails, { cancelUncompleted: true })
    subscribeToBorrowerEmails(__: StateContext<MessageStateModel>, { borrowerId }: SubscribeToBorrowerEmails) {
        this.pusherService
        .subscribe(`private-borrower-${borrowerId}-messages`)
        .bind_global(this.handleNewEmailPusherEvent.bind(this, borrowerId));
    }

    pusherSubscribe(borrowerId: number) {
        this.pusherService
            .subscribe(`private-borrower-${borrowerId}-messages`)
            .bind_global(this.handlePusherEvent.bind(this, borrowerId));
    }

    handlePusherEvent(borrowerId: number, eventName: string) {
        if (eventName.startsWith('message-')) {
            this.store.dispatch(new GetMessageThreadHistory(borrowerId, true));
        }
    }

    handleNewEmailPusherEvent(borrowerId: number, eventName: string) {
        if (eventName.startsWith('message-')) {
            this.store.dispatch(new RefreshInboxEmailList(borrowerId));
        }
    }

    pusherUnsubscribe(borrowerId: number) {
        this.pusherService.unsubscribe(`private-borrower-${borrowerId}-messages`);
    }

    dismissDelay() {
        setTimeout(() => {
            this.store.dispatch(new MessageAlertDismissed());
        }, 5000);
    }

    private sortThreads(threadList: Thread[]) {
        threadList.sort((a: Thread, b: Thread): number => {
            const aSortValue = a.messages.length === 1
                && a.messages[0].hubspotEmailTemplateId ? a.messages[0].created as string : a.modified;
            const bSortValue = b.messages.length === 1
                && b.messages[0].hubspotEmailTemplateId ? b.messages[0].created as string : b.modified;
            return bSortValue > aSortValue ? 1 : -1;
        });
    }

    //helper function to calculate if a date is older than 24 hours
    private calculateHourDifference(date) {
        const currentDate = new Date().toLocaleString('en-US', { timeZone: 'America/Denver' });
        const dbDate = new Date(date);
        const msInHour = 1000 * 60 * 60;
        const hours = Math.round(
            Math.abs(new Date(currentDate).getTime() - dbDate.getTime()) / msInHour,
        );
        return hours >= 24;
    }

    private getCurrentTimezoneDate(date: string) {
        return format(new Date(date + ' MST'),  'yyyy-MM-dd HH:mm:ss');
    }

    private removeDuplicates(originalArray, newArray) {
        let results = cloneDeep(newArray);
        const missing = originalArray.filter(obj => {
            if (!newArray.map(o => o['threadId']).includes(obj['threadId'])) {
                return obj;
            }
        });
        if (!!(missing.length > 0)) {
            results = results.concat(...missing);
        }
        return results;
    }
}
